import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { PROMO_FEATURE } from '../store';
import { reducerProvider, reducerToken } from './reducers';

function promoStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [PROMO_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(PROMO_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(promoStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class PromoStoreModule {}
